import tw, { styled } from 'twin.macro';

const AppContainer = styled.div`
  ${tw`min-h-screen flex flex-col ml-0 w-full h-screen overflow-y-auto`}
  box-sizing: border-box;
  flex: 1 1 100%;
`;

export default AppContainer;
